// @flow
import type { DailySummary } from "../../lib/OnlineTypes";
import type { CompanyBranch } from "../../lib/Types";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import React from "react";
import styled, { css } from "styled-components";
import Input from "../Input";
import Button from "../Button";
import { DateRangePicker } from "react-dates";
import { fetchJson } from "../../lib/Fetching";
import moment from "moment";
import CompanyBranchDropDown from "../crm/CompanyBranchDropDown";
import RegistrationUsersDropDown from "../crm/RegistrationUsersDropDown";
import DataFieldFilter from "./DataFieldFilter";
import CompanyDropDown from "../crm/CompanyDropDown";
import { MinimalContainer } from "./Theme";
import MatrixInput from "../testing/MatrixInput";
import TestingCategorySelect from "../sample_reception/TestingCategorySelect";
import OutstandingTodosInput from "../sample_testing/inputs/OutstandingTodosInput";
import WithdrawnSamplesInput from "../sample_testing/inputs/WithdrawnSamplesInput";
import { renderMonthElement } from "../common/CalendarUtils";
import DropDown from "../DropDown";
import DateFilter from "../common/form/DateFilter";

type Props = {
  company_id: ?number,
  onLoadSummary: (DailySummary) => void,
  canFindCompany: boolean,
  runSearch: boolean,
  laboratory_company_id: ?number,
  clientView: ?boolean,
};

type State = {
  company_id: ?number,
  companyBranch: ?CompanyBranch,
  loading: boolean,
  product_name: ?string,
  start_date: ?Object,
  end_date: ?Object,
  startDateFocused: boolean,
  endDateFocused: boolean,
  matrixId: ?number,
  testingCategory: ?number,
  outstandingTodos: boolean,
  withdrawnSamples: boolean,
};

const Container = styled(MinimalContainer)`
  padding: 20px;
  max-width: 1920px;
  margin: 0 auto;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
`;

const Column = styled.div`
  flex-grow: 1;
  min-width: 350px;
  padding: 0 15px;
  margin-bottom: 5px;
`;

const FullColumn = styled.div`
  width: 100%;
  padding: 0 15px;
`;
export default class DailySummarySearch extends React.Component<Props, State> {
  state = {
    company_id: this.props.company_id,
    companyBranch: null,
    loading: false,
    product_name: "",
    start_date: moment().subtract(14, "days"),
    end_date: moment(),
    startDateFocused: false,
    endDateFocused: false,
    testingCategory: null,
    userId: null,
    outstandingTodos: false,
    withdrawnSamples: false,
    fexpSamples: false,
    received: "all",
    dateFilter: this.props.dateFilter || "registered",
  };

  componentDidMount() {
    if (this.props.runSearch) {
      this.loadData();
    }
  }

  isValid = (): boolean => {
    const { start_date, end_date } = this.state;
    if (!start_date || !end_date) return false;
    if (end_date < start_date) return false;
    return true;
  };

  loadData = () => {
    const { onLoadSummary, laboratory_company_id } = this.props;
    const {
      company_id,
      product_name,
      dateFilter,
      start_date,
      end_date,
      companyBranch,
      matrixId,
      testingCategory,
      outstandingTodos,
      withdrawnSamples,
      userId,
      fexpSamples,
      received,
    } = this.state;
    this.setState({ loading: true });
    onLoadSummary(null, null);

    const formParams = {
      company_id,
      form: {
        company_ids: [company_id],
        company_branch_ids: companyBranch ? [companyBranch.id] : null,
        product_name,
        date_filter: dateFilter,
        start_date: start_date ? start_date.format("YYYY-MM-DD") : null,
        end_date: end_date ? end_date.format("YYYY-MM-DD") : null,
        data_fields: this.dataFieldFilter ? this.dataFieldFilter.queryParams() : [],
        matrix_id: matrixId,
        testing_category_id: testingCategory,
        outstanding_todos: outstandingTodos,
        show_withdrawn_samples: withdrawnSamples,
        user_id: userId,
        fexp: fexpSamples,
        laboratory_company_id,
        received,
      },
    };

    fetchJson("/lims_sample_reporting/daily_summary.json", formParams)
      .then((json) => {
        this.setState({ loading: false });
        onLoadSummary(json.daily_summary, formParams);
      })
      .catch((e) => {
        this.setState({ loading: false });
        alert("There was a problem loading this data.");
        throw e;
      });
  };

  branchChanged = (companyBranch: CompanyBranch) => {
    this.setState({
      companyBranch,
    });
  };

  userChanged = (userId) => {
    this.setState({ userId });
  };

  render() {
    const { canFindCompany, clientView } = this.props;
    const {
      company_id,
      loading,
      product_name,
      dateFilter,
      start_date,
      end_date,
      startDateFocused,
      endDateFocused,
      companyBranch,
      testingCategory,
      outstandingTodos,
      withdrawnSamples,
      fexpSamples,
      userId,
      received,
    } = this.state;
    const receivedOptions = [
      { label: "Show All", value: "all" },
      { label: "Not Received", value: "not_received" },
      { label: "Received", value: "received" },
    ];

    const dateOptions = clientView
      ? ["registered", "requested_test_date"]
      : ["registered", "requested_test_date", "first_received_by_lab_date"];

    return (
      <Container>
        <Row>
          <Column>
            <label>{I18n.t("testing_category")}</label>
            <TestingCategorySelect
              value={testingCategory}
              onChange={(o) => this.setState({ testingCategory: o.value })}
            />
          </Column>
          <Column>
            {/* <label>{I18n.t("registered_between")}</label> */}
            <DateFilter
              clientView={true}
              setDateFilter={(dateFilter) => this.setState({ dateFilter })}
              dateFilter={dateFilter}
              start_date={start_date}
              end_date={end_date}
              onDatesChange={({ start_date, end_date }) =>
                this.setState({ start_date, end_date })
              }
              only={dateOptions}
            />
            <br />
            {false && (
              <DateRangePicker
                startDateId="start_date"
                startDate={start_date}
                endDateId="end_date"
                endDate={end_date}
                numberOfMonths={1}
                onDatesChange={({ startDate, endDate }) =>
                  this.setState({ start_date: startDate, end_date: endDate })
                }
                focusedInput={this.state.focusedInput || null}
                onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                showClearDates={true}
                isOutsideRange={() => false}
                hideKeyboardShortcutsPanel={true}
                displayFormat="DD MMM YYYY"
                minimumNights={0}
                renderMonthElement={renderMonthElement}
              />
            )}
          </Column>
          {canFindCompany && (
            <Column>
              <label>{I18n.t("company")}</label>
              <CompanyDropDown onChange={(company_id) => this.setState({ company_id })} />
            </Column>
          )}
          {company_id && (
            <Column>
              <label>{I18n.t("select_branch")}</label>
              <CompanyBranchDropDown
                key={company_id}
                company_id={company_id}
                onBranchChange={this.branchChanged}
                value={companyBranch ? companyBranch.id : null}
                includeBlank={true}
                blankLabel={"All Branches"}
                permission_code={"view_samples"}
              />
            </Column>
          )}
          {company_id && (
            <Column>
              <label>{I18n.t("select_registerer")}</label>
              <RegistrationUsersDropDown
                key={company_id}
                company_id={company_id}
                onChange={this.userChanged}
                value={userId}
              />
            </Column>
          )}
          <Column>
            <label>{I18n.t("product_name")}</label>
            <Input
              focus
              onPressEnter={this.loadData}
              className="form-control"
              value={product_name}
              onChange={(e) => this.setState({ product_name: e.target.value })}
            />
          </Column>
          <Column>
            <label>{I18n.t("matrix")}</label>
            <MatrixInput
              multiple={false}
              onChange={(option) => this.setState({ matrixId: option ? option.value : null })}
              defaultStyle
            />
          </Column>
          <Column>
            <label>{I18n.t("received_status")}</label>
            <br />
            <DropDown
              onChange={(dropDownItem) => this.setState({ received: dropDownItem.value })}
              options={receivedOptions}
              value={received}
            />
          </Column>
        </Row>
        <Row>
          <FullColumn style={{ marginBottom: 0, paddingBottom: 0, marginTop: 10 }}>
            <label>
              <OutstandingTodosInput
                value={outstandingTodos}
                onChange={(val) => this.setState({ outstandingTodos: val })}
              />
              &nbsp; {I18n.t("with_outstanding_todos")}
            </label>
            <label style={{ marginLeft: 30 }}>
              <WithdrawnSamplesInput
                value={withdrawnSamples}
                onChange={(val) => this.setState({ withdrawnSamples: val })}
              />
              &nbsp; {I18n.t("show_withdrawn_samples")}
            </label>
            <label style={{ marginLeft: 30 }}>
              <WithdrawnSamplesInput
                value={fexpSamples}
                onChange={(val) => this.setState({ fexpSamples: val })}
              />
              &nbsp; {I18n.t("show_fexp_samples")}
            </label>
          </FullColumn>
        </Row>
        {company_id && (
          <Row style={{ paddingBottom: 0, paddingTop: 0 }}>
            <FullColumn>
              <DataFieldFilter
                key={company_id}
                ref={(ref) => (this.dataFieldFilter = ref)}
                onSubmit={this.loadData}
                company_id={company_id}
                company_branch_id={companyBranch ? companyBranch.id : null}
              />
            </FullColumn>
          </Row>
        )}
        <Row>
          <Column style={{ marginBottom: 0, paddingBottom: 0 }}>
            <Button
              disabled={!this.isValid()}
              title={loading ? I18n.t("loading") : I18n.t("view_summary")}
              icon="fa-search"
              onClick={this.loadData}
            />
          </Column>
        </Row>
      </Container>
    );
  }
}
